module.exports = __webpack_public_path__ + "static/img/bg_1.ebab4032.png";